import Model, { attr, belongsTo } from '@ember-data/model';

// This model mirrors ./redirection-token.js (see app/services/api-flow-manager.js for why both
// exist). Partner-derived getters here (isLegalPlace, isEmbedded, isAccountant, ...) must stay in
// sync with that model's — this one is only reached as a fallback when the other 404s.
export default class RegisterRedirectionToken extends Model {
  @attr('string') flowUserType;
  @attr('string') ownerEmail;
  @attr('string') partnerName;
  @attr('string') ownerFirstName;
  @attr('string') organizationName;
  @attr('string') organizationId;
  @attr('string') flowType;
  @attr('string') organizationLegalCountry;
  @attr('string') legalFlow;
  @attr('string') locale;
  @attr('string') partnerType;
  @attr('boolean') companyCreationFromScratch;

  @belongsTo('partner-registration', { polymorphic: true, async: true, inverse: null })
  partnerRegistration;

  get registrationID() {
    return this.belongsTo('partnerRegistration').id();
  }

  get isLegalPlace() {
    return this.partnerName?.toLowerCase() === 'legal-place';
  }

  get isEmbedded() {
    return this.partnerType === 'embed';
  }

  get isAccountant() {
    return this.partnerType === 'accountant';
  }
}
